const isExpired = (timestamp: number, ttl: number | undefined) =>
  ttl ? Date.now() - timestamp > ttl : false;

export default isExpired;
